import { useCallback } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import useOffer from 'hooks/Offers/useOffer'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import generateTourBundleUserCartItems from 'lib/tours/generateTourBundleUserCartItems'
import { getTwinFlashAccommodation } from 'lib/tours/addBundlePriceToTourOffer'

export default function useTourBundleUserCartItems(offer: App.Tours.TourV2Offer | undefined) {
  const bundle = useAppSelector(state => offer ? state.tour.bundlesByTourId[offer.id]?.data : undefined)
  const isBundled = !!offer?.ltleBundleId
  const accommodation = bundle ? getTwinFlashAccommodation(bundle) : undefined
  const hotelId = isBundled && bundle?.id === offer?.ltleBundleId ? accommodation?.offerId : undefined
  const [loadedOffer, fetching, fetchError] = useOffer<App.HotelOffer>(hotelId)
  const hotel = isFlashHotelOffer(loadedOffer) && Array.isArray(loadedOffer.packages) ? loadedOffer : undefined
  const packageFound = hotel && accommodation && hotel.packages.some(pkg =>
    (pkg.id === accommodation.packageId || pkg.lePackageId === accommodation.packageId) &&
    pkg.duration === accommodation.nights && !!pkg.roomRate?.id,
  )
  const error = isBundled && (!!fetchError || (!!bundle && (!accommodation || bundle.id !== offer?.ltleBundleId)) || (!!loadedOffer && !isFlashHotelOffer(loadedOffer)) || (!!hotel && !packageFound))
  const loading = isBundled && !error && (!bundle || !hotel || fetching)

  const generateUserCartItems = useCallback((tourItems: Array<App.Checkout.TourV2Item>) =>
    generateTourBundleUserCartItems(tourItems, bundle, hotel, offer), [bundle, hotel, offer])

  return { loading, error, generateUserCartItems }
}
